import React from 'react';

import {connect} from 'react-redux';
import cn from "classnames";
import Pagination from 'rc-pagination';

import styles from '../../lib/global.css';
import ProjectList from '../../components/project-list/project-list.jsx';

// import MyFooter from '../../components/footer/footer.jsx';

import {setRecommendedProjects, setMyProjects, setMyShareProjects} from '../../reducers/teach';
import {getRecommendedProjects, getMyProjects} from '../../api/project';
import {shareList} from '../../api/share';
import Page from "../../components/page/page";
import PropTypes, {object} from "prop-types";
import Card from "../../components/card/card";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";



class ProjectsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            currentPage: 1,
            pageSize: 100
        }
        this.onPageChange = this.onPageChange.bind(this)
    }

    componentDidMount() {
        this.getData()
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user.id !== nextProps.user.id) {
            this.getData()
        }
    }

    getData(currentPage = 1) {
        if (this.props.match.params.filter == 'mine') {
            getMyProjects({page_size: this.state.pageSize, page: currentPage}, {quiet: this.props.myProjects.data.length > 0}).then(res => {
                this.props.setMyProjects(res)
                this.setState({ total: res.total })
            });
        } else if (this.props.match.params.filter == 'recommended') {
            getRecommendedProjects({page_size: this.state.pageSize, page: currentPage}, {quiet: this.props.recommendedProjects.data.length > 0}).then(res => {
                this.props.setRecommendedProjects(res)
                this.setState({ total: res.total })
            });
        } else if (this.props.match.params.filter == 'myshare') {
            shareList({page_size: this.state.pageSize, page: currentPage}, {quiet: this.props.shareProjects.data.length > 0}).then(res => {
                this.props.setMyShareProjects(res)
                this.setState({ total: res.total })
            });
        }
    }

    onPageChange(e) {
        this.setState({ currentPage: e })
        this.getData(e)
    }

    oldVersion() {
        window.open('https://v1.scratch-edu.com/#/projects', '_blank');
    }

    render() {
        let myProjectListData;
        const obj = {id: null, title: "前往旧版 “我的作品”"}
        if (this.props.myProjects.data.length > 0) {
            myProjectListData = [{id: 0, img: require('./start_create.png')}].concat(this.props.myProjects.data);
            myProjectListData.push(obj);
        } else {
            myProjectListData = [{id: 0, img: require('./start_create.png')}, obj];
        }
        const title = this.props.match.params.filter == 'mine' ? window.L('teach.project.myProjects') : this.props.match.params.filter == 'mine' ? window.L('teach.project.recommendedProjects') : '我的分享';
        return (
            <Page isModal={true} title={title}>
                <div style={{position: 'fixed', top: 0, right: 0, color: '#fff', lineHeight: '50px', width: '100px', textAlign: 'center', zIndex: 99, cursor: 'pointer'}} onClick={() => {this.oldVersion()}}>旧版作品</div>
                <PageContentMargin>
                    {this.props.match.params.filter == 'mine' ? (
                        <ProjectList
                            allowDelete={true}
                            items={myProjectListData}
                        />
                    ) : null}
                    {this.props.match.params.filter == 'recommended' ? (
                        <ProjectList
                            items={this.props.recommendedProjects.data}
                        />
                    ) : null}
                    {this.props.match.params.filter == 'myshare' ? (
                        this.props.shareProjects.data.length > 0 ? (
                            <ProjectList
                                allowDelete={true}
                                items={this.props.shareProjects.data}
                            />
                        ) : (
                            <span style={{width:'70px',height:'50px',position:'absolute',top:0,left:0,bottom:0,right:0,margin:'auto'}}>暂无分享</span>
                        )
                    ) : null}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Pagination 
                            current={this.state.currentPage}
                            defaultPageSize={this.state.pageSize}
                            total={this.state.total}
                            onChange={this.onPageChange}
                        ></Pagination>
                    </div>
                </PageContentMargin>
                {/* <MyFooter /> */}
            </Page>
        );
    }
}
ProjectsPage.propTypes = {
    recommendedProjects: PropTypes.object,
    setRecommendedProjects: PropTypes.func,
    myProjects: PropTypes.object,
    setMyProjects: PropTypes.func,
    shareProjects: PropTypes.object,
    setMyShareProjects: PropTypes.func,
    user: PropTypes.object
}

const mapStateToProps = state => ({
    recommendedProjects: state.teach.recommendedProjects,
    myProjects: state.teach.myProjects,
    shareProjects: state.teach.shareProjects,
    user: state.teach.user
});

const mapDispatchToProps = dispatch => ({
    setRecommendedProjects: projects => dispatch(setRecommendedProjects(projects)),
    setMyProjects: projects => dispatch(setMyProjects(projects)),
    setMyShareProjects: projects => dispatch(setMyShareProjects(projects)),
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectsPage);
